import React from 'react';
import { ThemeProvider } from './theme/ThemeContext';
import ModernDashboard from './pages/ModernDashboard';

function App() {
  return (
    <ThemeProvider>
      <ModernDashboard />
    </ThemeProvider>
  );
}

export default App;
